<template>

  <tr>
    <td>
      <m-a target="_blank" :href="item.link">لینک</m-a>
    </td>
    <td>{{ item.xpath }}</td>
    <td>{{ crawlerPositionName }}</td>
    <td>
      <b-badge class="mx-1 cursor_pointer rounded-pill" @click="removeCrawler(item)">حذف</b-badge>
      <b-badge v-b-modal="`update-crawler-${item.id}`" class="mx-1 cursor_pointer rounded-pill">ویرایش</b-badge>
    </td>

    <b-modal :id="`update-crawler-${item.id}`" hide-footer>
      <div class="text-right">
        <crawler-form :product="product" :crawler="item" :crawler-type="item.crawlerable_type"
                      :crawlerable-id="item.id"/>
      </div>
    </b-modal>


  </tr>

</template>

<script>
import CrawlerForm from "./CrawlerForm";
import {productFeatureName} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {crawlerPositionExtraOptions} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Crawler";

export default {
  name: "CrawlerItem",
  components: {CrawlerForm},
  props: {
    item: {},
    product: {}
  },
  data() {
    return {
      crawlerPositionExtraOptions
    }
  },
  computed: {
    crawlerPositionName() {

      if (this.item.crawlerable_column != 'feature') {
        return this.item.crawlerable_column
      }

      let features = this.product.features
      let selectedFeature = features.find(item => item.id == this.item.crawlerable_column_id)

      let featureName = this.productFeatureName(this.product, selectedFeature.id);

      if (selectedFeature.variation == 0) {
        return featureName
      }

      return `${featureName} (${this.crawlerPositionExtraOptions[this.item.extra.position]})`
    }
  },
  methods: {
    productFeatureName,
    removeCrawler(crawler) {
      if (confirm("از حذف ایتم اطمینان دارید؟")) {
        this.$store.dispatch('Crawler/deleteCrawler', crawler)
      }
    },
  }
}
</script>

<style scoped>
.cursor_pointer {
  cursor: pointer;
}
</style>